// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pers-info-modal__content-wrapper .sk-select__list {\n  max-height: 100px;\n}\n.dashboard-pers-info .sk-modal__wrapper {\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
